import script from "./HRDiagramDiagnostics.vue?vue&type=script&setup=true&lang=js"
export * from "./HRDiagramDiagnostics.vue?vue&type=script&setup=true&lang=js"

import "./HRDiagramDiagnostics.vue?vue&type=style&index=0&id=241fa421&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241fa421"]])

export default __exports__